module.exports = __webpack_public_path__ + "img/techno-bg.f7647a4b.jpg";